export { SpinnerComponent as Spinner, ISpinnerProps, ISpinnerState } from './Spinner.component';
export { SpinnerService, spinnerService } from './spinner.service';